import { useState } from "react";
import { api } from "../utils/apiHandler";

export function useUserApi() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateUser = async payload => {
    const rawHandle = localStorage.getItem("handle");
    const handle = rawHandle ? JSON.parse(rawHandle) : null;
    const id = handle?.user?.id;

    if (!id) {
      setError(new Error("User ID not found"));
      return null;
    }

    try {
      setIsLoading(true);
      setError(null);
      const res = await api.patch(`/users/${id}`, payload);

      const updatedHandle = {
        token: handle.token,
        user: res.data,
      };
      localStorage.setItem("handle", JSON.stringify(updatedHandle));
      return res.data;
    } catch (err) {
      setError(err);
      throw new Error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { updateUser, isLoading, error };
}
